import OrderService from "../../services/OrderService";
import normaliseMerchandiseData from "../../utils/normaliseMerchandiseData";
export const GET_SUMMARY_REQUEST = "GET_SUMMARY_REQUEST";
export const GET_SUMMARY_SUCCESS = "GET_SUMMARY_SUCCESS";
export const GET_SUMMARY_ERROR = "GET_SUMMARY_ERROR";

export const loadSummary = (
  id,
  requestedTickets,
  clientDonation,
  order,
  merch,
  giftCard,
  isEventId = true
) => {
  let normalisedMerchData;
  if (merch) {
    normalisedMerchData = normaliseMerchandiseData(merch);
  }
  return dispatch => {
    dispatch({ type: GET_SUMMARY_REQUEST });
    OrderService.summary(
      id,
      requestedTickets,
      clientDonation,
      order,
      normalisedMerchData,
      giftCard,
      isEventId
    )
      .then(result => {
        dispatch({
          type: GET_SUMMARY_SUCCESS,
          summary: result,
          tickets: result.tickets
        });
      })
      .catch(err => {
        dispatch({ type: GET_SUMMARY_ERROR, error: "Summary failed to load" });
      });
  };
};
